import { render, staticRenderFns } from "./EvaluationDimension.vue?vue&type=template&id=d4a33be2&scoped=true"
import script from "./EvaluationDimension.vue?vue&type=script&lang=js"
export * from "./EvaluationDimension.vue?vue&type=script&lang=js"
import style0 from "./EvaluationDimension.vue?vue&type=style&index=0&id=d4a33be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a33be2",
  null
  
)

export default component.exports